import { updateAccordions } from './accordions';
import { updateHeaderAccordions } from './header-accordion';

window.addEventListener('resize', () => {
    updateAccordions();
    updateHeaderAccordions();
}, { passive: true });